import { ITipConfigurationState, initialTipConfiguration } from '../initialStates/tipConfiguration';
import { TipConfigurationAction } from '../actions/tipConfigurationActions';
import { TIP_CONFIGURATION_ACTION_TYPES } from '../actions/tipConfigurationActionTypes';

export const tipConfigurationReducer = (
  state: ITipConfigurationState = initialTipConfiguration,
  action: TipConfigurationAction
): ITipConfigurationState => {
  switch (action.type) {
    case TIP_CONFIGURATION_ACTION_TYPES.FETCH_TIP_CONFIGURATION_BEGIN:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case TIP_CONFIGURATION_ACTION_TYPES.FETCH_TIP_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload,
        initialized: true,
      };

    case TIP_CONFIGURATION_ACTION_TYPES.FETCH_TIP_CONFIGURATION_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case TIP_CONFIGURATION_ACTION_TYPES.UPDATE_TIP_CONFIGURATION_BEGIN:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case TIP_CONFIGURATION_ACTION_TYPES.UPDATE_TIP_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload,
      };

    case TIP_CONFIGURATION_ACTION_TYPES.UPDATE_TIP_CONFIGURATION_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};